// extracted by mini-css-extract-plugin
export var icon = "_a7-3";
export var subtitle = "_a7-2";
export var title = "_a7-1";
export var value = "_a7-0";